<template>
  <v-layout>
    <d-header>
      <h1 class="title">
        {{ $t("dashboard") }}
      </h1>
    </d-header>

    <d-container>
      <div class="columns is-multiline mb-3 dashboard-kpis">
        <div
          class="column is-half is-one-quarter-widescreen"
        >
          <div class="box is-primary">
            <h2 class="title is-1">
              {{ model.number_properties_rented_in_last_12_months }}
            </h2>
            <p class="subtitle is-7 has-text-grey">
              {{ $t('number_properties_rented_in_last_12_months').capitalize() }}
            </p>
          </div>
        </div>
        <div
          class="column is-half is-one-quarter-widescreen"
        >
          <div class="box">
            <h2 class="title is-1">
              {{ model.number_properties_rented_in_last_months }}
            </h2>
            <p class="subtitle is-7 has-text-grey">
              {{ $t('number_properties_rented_in_last_months').capitalize() }}
            </p>
          </div>
        </div>
        <div
          class="column is-half is-one-quarter-widescreen"
        >
          <div class="box">
            <h2 class="title is-1">
              {{ model.number_properties_in_for_rent }}
            </h2>
            <p class="subtitle is-7 has-text-grey">
              {{ $t('number_properties_in_for_rent').capitalize() }}
            </p>
          </div>
        </div>
        <div
          class="column is-half is-one-quarter-widescreen"
        >
          <div class="box">
            <h2 class="title is-1">
              {{ model.number_properties_in_application }}
            </h2>
            <p class="subtitle is-7 has-text-grey">
              {{ $t('number_properties_in_application').capitalize() }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="$roleCan([$laravel.role_admin])"
        class="columns is-multiline mb-3 dashboard-links"
      >
        <div
          v-if="!$roleCan([$laravel.role_client, $laravel.role_employee])"
          class="column is-one-third"
        >
          <router-link to="/users">
            <d-stamp
              icon="account"
              color="success"
            >
              <h2 class="title is-6">
                {{ model.employees }}
              </h2>
              <h3 class="subtitle is-6 has-text-grey">
                {{ $t("employee").capitalize() }}
              </h3>
            </d-stamp>
          </router-link>
        </div>
        <div class="column is-one-third">
          <router-link to="/properties">
            <d-stamp
              icon="newspaper"
              color="grey"
            >
              <h2 class="title is-6">
                {{ model.properties }}
              </h2>
              <h3 class="subtitle is-6 has-text-grey">
                {{ $t("properties").capitalize() }}
              </h3>
            </d-stamp>
          </router-link>
        </div>
        <div
          v-if="!$roleCan([$laravel.role_client])"
          class="column is-one-third"
        >
          <router-link to="/owners">
            <d-stamp
              icon="account"
              color="success"
            >
              <h2 class="title is-6">
                {{ model.owners }}
              </h2>
              <h3 class="subtitle is-6 has-text-grey">
                {{ $t("owners").capitalize() }}
              </h3>
            </d-stamp>
          </router-link>
        </div>
      </div>
    </d-container>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      model: {
        properties: 0,
        owners: 0,
        employees: 0,
        number_properties_rented_in_last_12_months: 0,
        number_properties_rented_in_last_months: 0,
        number_properties_in_for_rent: 0,
        number_properties_in_application: 0,
      },
    };
  },
  metaInfo() {
    return {
      title: this.$t("dashboard").capitalize(),
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$http
        .get(this.$laravel.route("api.dashboard"))
        .then((response) => {
          this.loading = false;
          this.model = { ...response.data };
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>
